<bn-loading-overlay></bn-loading-overlay>
<div *ngIf="dataLimites" class="container text-center letra-miuda">
    Consulta realizada em: {{ dataLimites }}
</div>
<div class="table-responsive" *ngIf="limites && limites.length && tranche">
    <table class="table">
        <thead>
        <tr>
            <th *ngIf="limites[0].agenteFinanceiro?.nome">Agente Financeiro</th>
            <th class="titulo-moeda" *ngIf="tranchePossuiVLMei">{{ siglaMei }} (R$)</th>
            <th class="titulo-moeda" *ngIf="tranchePossuiVLMi">{{ siglaMi }} (R$)</th>
            <th class="titulo-moeda" *ngIf="tranchePossuiVLP">{{ siglaP }} (R$)</th>
            <th class="titulo-moeda" *ngIf="tranchePossuiVLM">{{ siglaM }} (R$)</th>
            <th class="titulo-moeda" *ngIf="tranchePossuiVLG">{{ siglaG }} (R$)</th>
            <th class="titulo-moeda">{{ siglaValorLiberado }} (R$)</th>
            <th class="titulo-moeda">VHO (R$)</th>
            <th class="titulo-moeda">VRO (R$)</th>
            <th class="titulo-moeda" *ngIf="deveExibirCMI(tranche)">CMI (R$)</th>
            <th class="titulo-moeda" *ngIf="modalidadeGarantiaDTO.realizaCalculoTaxasEquivalentes">Fator* (%)
              <i class="fa fa-question-circle help-subtitulo" placement="bottom" ngbTooltip="Média aritmética simples dos fatores de redução obtidos em cada cálculo anterior"></i></th>
            <th class="titulo-moeda" *ngIf="modalidadeGarantiaDTO.realizaCalculoTaxasEquivalentes">CMI Após Fator (R$)</th>
            <th class="titulo-moeda" *ngIf="exibeCamposRCMI">RCMI (R$)</th>
            <th class="titulo-moeda" *ngIf="exibeCamposRCMI">CMI após RCMI (R$)</th>
            <th class="titulo-moeda">LDC (R$)</th>
            <th scope="col"></th> <!--lupa para visualizar os detalhes-->
          </tr>
        </thead>
        <tbody>
        <tr *ngFor="let limite of limites">
            <td *ngIf="limites[0].agenteFinanceiro?.nome">
                {{limite.agenteFinanceiro?.nome | truncate:[40]}}
            </td>
           <td class="moeda" *ngIf="tranchePossuiVLMei">
              {{limite.liberadoMicroemprendedorIndividualEmpresas| bnMask:'MOEDA'}}
          </td>
            <td class="moeda" *ngIf="tranchePossuiVLMi">
              {{limite.liberadoMicroEmpresas | bnMask:'MOEDA'}}
          </td>
            <td class="moeda" *ngIf="tranchePossuiVLP">
                {{limite.liberadoEmpresasPequenas | bnMask:'MOEDA'}}
            </td>
            <td class="moeda" *ngIf="tranchePossuiVLM">
                {{limite.liberadoEmpresasMedias | bnMask:'MOEDA'}}
            </td>
            <td class="moeda" *ngIf="tranchePossuiVLG">
              {{limite.liberadoEmpresasGrandes | bnMask:'MOEDA'}}
            </td>
            <td class="moeda">
                {{limite.vlo | bnMask:'MOEDA'}}
            </td>
            <td class="moeda">
                {{limite.vho | bnMask:'MOEDA'}}
            </td>
            <td class="moeda">
                {{limite.vro | bnMask:'MOEDA'}}
            </td>
            <td class="moeda" *ngIf="deveExibirCMI(tranche)">
                {{limite.coberturaMaximaInadimplencia | bnMask:'MOEDA'}}
            </td>
            <td class="moeda" *ngIf="modalidadeGarantiaDTO.realizaCalculoTaxasEquivalentes">
                {{limite.fatorRedutor | bnMask:'DECIMAL': '2'}}
            </td>
            <td class="moeda" *ngIf="modalidadeGarantiaDTO.realizaCalculoTaxasEquivalentes">
              {{limite.cmiAposFator | bnMask:'MOEDA'}}
            </td>
            <td class="moeda" *ngIf="exibeCamposRCMI">
                {{limite.valorRcmi | bnMask:'MOEDA'}}
            </td>
            <td class="moeda" *ngIf="exibeCamposRCMI">
                {{limite.cmiAposRcmi | bnMask:'MOEDA'}}
            </td>
            <td class="moeda">
                {{limite.limiteDisponivel | bnMask:'MOEDA'}}
            </td>
            <td>
                <a href="javascript:void(0)" (click)="exportarRelatorioAnalitico(limite.ide)">
                    <i class="fa fa-download"></i>
                </a>
            </td>
        </tr>
        <tr *ngIf="limites?.length">
          <td><strong> TOTAL</strong></td>

          <td class="moeda" *ngIf="tranchePossuiVLMei">
            {{somarColuna('liberadoMei') | bnMask:'MOEDA'}}
          </td>

          <td class="moeda" *ngIf="tranchePossuiVLMi">
            {{somarColuna('liberadoMicroEmpresas') | bnMask:'MOEDA'}}
          </td>

          <td class="moeda" *ngIf="tranchePossuiVLP">
            {{somarColuna('liberadoEmpresasPequenas') | bnMask:'MOEDA'}}
          </td>

          <td class="moeda" *ngIf="tranchePossuiVLM">
            {{somarColuna('liberadoEmpresasMedias') | bnMask:'MOEDA'}}
          </td>

          <td class="moeda" *ngIf="tranchePossuiVLG">
            {{somarColuna('liberadoEmpresasGrandes') | bnMask:'MOEDA'}}
          </td>

          <td class="moeda">
            {{somarColuna('vlo') | bnMask:'MOEDA'}}
          </td>

          <td class="moeda">
            {{somarColuna('vho') | bnMask:'MOEDA'}}
          </td>

          <td class="moeda">
            {{somarColuna('vro') | bnMask:'MOEDA'}}
          </td>

          <td class="moeda" *ngIf="deveExibirCMI(tranche)">
            {{somarColuna('coberturaMaximaInadimplencia') | bnMask:'MOEDA'}}
          </td>

          <td class="moeda" *ngIf="modalidadeGarantiaDTO.realizaCalculoTaxasEquivalentes">

          </td>

          <td class="moeda" *ngIf="modalidadeGarantiaDTO.realizaCalculoTaxasEquivalentes">
            {{somarColuna('cmiAposFator') | bnMask:'MOEDA'}}
          </td>

          <td class="moeda" *ngIf="exibeCamposRCMI">
            {{somarColuna('valorRcmi') | bnMask:'MOEDA'}}
          </td>

          <td class="moeda" *ngIf="exibeCamposRCMI">
            {{somarColuna('cmiAposRcmi') | bnMask:'MOEDA'}}
          </td>

          <td class="moeda">
            {{somarColuna('limiteDisponivel') | bnMask:'MOEDA'}}
          </td>

          <td></td>
        </tr>
        </tbody>
    </table>
    <p *ngIf="modalidadeGarantiaDTO.realizaCalculoTaxasEquivalentes"> <span class="fw-bold">*</span>Fator Conforme Art. dos programas de garantia do PEAC</p>

    <table class="table table-bordered table-sm legenda">
      <tr>
        <th>Sigla</th>
        <th>Descrição</th>
      </tr>
      <tr *ngIf="tranchePossuiVLMei">
          <td>{{ siglaMei }}</td>
          <td>{{ textoValorLiberadoLegenda }} para entidades microempreendedor individual</td>
      </tr>
      <tr *ngIf="tranchePossuiVLMi">
          <td>{{ siglaMi }}</td>
          <td>{{ textoValorLiberadoLegenda }} para entidades de porte micro</td>
      </tr>
      <tr *ngIf="tranchePossuiVLP">
          <td>{{ siglaP }}</td>
          <td>{{ textoValorLiberadoLegenda }} para entidades de pequeno porte</td>
      </tr>
      <tr *ngIf="tranchePossuiVLM">
          <td>{{ siglaM }}</td>
          <td>{{ textoValorLiberadoLegenda }} para entidades de médio porte</td>
      </tr>
      <tr *ngIf="tranchePossuiVLG">
          <td>{{ siglaG }}</td>
          <td>{{ textoValorLiberadoLegenda }} para entidades de grande porte</td>
      </tr>
      <tr>
        <td>{{ siglaValorLiberado }}</td>
        <td>{{ textoValorLiberadoLegenda }} das operações</td>
      </tr>
      <tr>
        <td>VHO</td>
        <td>Valor honrado e a honrar das operações</td>
      </tr>
      <tr>
        <td>VRO</td>
        <td>Valor recuperado das operações</td>
      </tr>
      <tr *ngIf="deveExibirCMI(tranche)">
        <td>CMI</td>
        <td>Cobertura máxima de inadimplência</td>
      </tr>
      <tr *ngIf="exibeCamposRCMI">
        <td>RCMI</td>
        <td>Renúncia a cobertura máxima de inadimplência</td>
      </tr>
      <tr>
        <td>LDC</td>
        <td>Limite disponível para cobertura</td>
      </tr>
    </table>
</div>
